import { useEffect, useRef, useCallback } from 'react'

const IDLE_TIMEOUT = 15 * 60 * 1000 // 15 minutes

export const useIdleLogout = (onLogout) => {
  const timerRef = useRef(null)

  const resetTimer = useCallback(() => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(onLogout, IDLE_TIMEOUT)
  }, [onLogout])

  useEffect(() => {
    const events = [
      'mousemove',
      'keydown',
      'click',
      'scroll',
      'touchstart',
    ]

    events.forEach((e) => window.addEventListener(e, resetTimer))
    resetTimer() // start timer immediately

    return () => {
      events.forEach((e) =>
        window.removeEventListener(e, resetTimer),
      )
      clearTimeout(timerRef.current)
    }
  }, [resetTimer])
}